//
//
//
//
//
//
//
//
//

import {
  CreditCardIcon
} from 'vue-feather-icons'
import TaskPrice from '@/components/tasks/TaskPrice.vue'
import TaskDetailsItem from '@/components/tasks/TaskDetailsItem'

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'TaskDetailsValue',
  components: {
    TaskDetailsItem,
    TaskPrice,
    CreditCardIcon
  },
  props: {
    task: {
      type: Object,
      required: true
    }
  }
}
